import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-gold/25 bg-[#310B17] text-white/80">
      <div className="absolute inset-0 grain" aria-hidden="true" />
      <div className="relative z-10 mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:grid-cols-3 sm:px-6 lg:px-8">
        <div>
          <div className="flex items-center gap-2.5">
            <img src="/assets/emblem.png" alt="Logo ENPALSBOX" className="h-9 w-9 rounded-lg ring-1 ring-gold/40" />
            <span className="font-heading text-lg font-bold text-white">ENPALSBOX</span>
          </div>
          <p className="mt-3 text-sm leading-relaxed">
            Tu pensa alla musica. Alla burocrazia pensiamo noi. Assistenza ad artisti e lavoratori dello spettacolo per gli adempimenti previdenziali.
          </p>
          <p className="mt-3 flex items-start gap-2 text-sm leading-relaxed" data-testid="footer-indirizzo">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
            <span>Via G. Carducci 64/C – Ghezzano (PI)</span>
          </p>
        </div>
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-gold">Servizi</h4>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/certificato-agibilita" className="hover:text-white">Certificato di Agibilità</Link></li>
            <li><Link to="/f24" className="hover:text-white">F24</Link></li>
            <li><Link to="/dichiarazione-mensile" className="hover:text-white">Dichiarazione Mensile</Link></li>
            <li><Link to="/news" className="hover:text-white">News</Link></li>
            <li><Link to="/calcolatore" className="hover:text-white">Calcolatore contributi</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-gold">Contatti</h4>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/contatti" className="hover:text-white">Contattaci</Link></li>
            <li>
              <a href="tel:+393791880225" data-testid="footer-tel-1" className="inline-flex items-center gap-1.5 hover:text-white">
                <Phone className="h-4 w-4 text-gold" /> 379 188 0225
              </a>
            </li>
            <li>
              <a href="tel:+393318296690" data-testid="footer-tel-2" className="inline-flex items-center gap-1.5 hover:text-white">
                <Phone className="h-4 w-4 text-gold" /> 331 829 6690
              </a>
            </li>
            <li>
              <a href="tel:+39050878852" data-testid="footer-tel-ufficio" className="inline-flex items-center gap-1.5 hover:text-white">
                <Phone className="h-4 w-4 text-gold" /> Ufficio: 050 878852 <span className="text-white/50">(lun–ven)</span>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/enpalsbox"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="instagram-link"
                className="inline-flex items-center gap-1.5 hover:text-white"
              >
                <Instagram className="h-4 w-4 text-gold" /> Seguici su Instagram
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="relative z-10 border-t border-white/10 py-4 text-center text-xs text-white/50">
        © {new Date().getFullYear()} ENPALSBOX — Tutti i diritti riservati
      </div>
    </footer>
  );
}
